/**
 * Dispatches request processing by route entry name.
 *
 * Builds a route processing handler that selects a route handler to dispatch to accordingly to the name of the first
 * route entry.
 *
 * Target route handler receives a route tail without first entry.
 *
 * @typeParam TMeans - Supported route processing means.
 * @param names - A map of request processing handlers for corresponding route entry names.
 *
 * @returns New route processing handler.
 */
export function dispatchByName(names) {
    return async ({ route, next }) => {
        const { path: [firstEntry], } = route;
        if (firstEntry) {
            const handler = names[firstEntry.name];
            if (handler) {
                await next(handler.bind(names), {
                    route: route.section(1),
                });
            }
        }
    };
}
//# sourceMappingURL=dispatch-by-name.handler.js.map